import {
  OrderedSection,
  renderOrderedItems,
  SummaryField,
  SummaryGroup,
  SummaryGroupFieldSet,
  SummarySection,
} from "@smart/bridge-intake-components-dom";
import { ProgressCircle } from "@smart/itops-sb-design-system-dom";

export const PreviewResponses = ({
  orderedSections,
  responses,
  loading,
}: {
  orderedSections: OrderedSection[];
  responses: Record<string, any>;
  loading: boolean;
}) => (
  <div className="flex flex-col h-full gap-xSmall overflow-y-hidden">
    <div className="w-full mb-2 text-ui font-semibold">Preview</div>
    <div
      data-testid="preview-responses"
      className="relative w-full h-full bg-white border border-neutral-100 rounded overflow-y-auto"
    >
      {loading ? (
        <ProgressCircle description="Loading..." />
      ) : (
        <div className="p-[3.2rem] rounded bg-white">
          {orderedSections.map(({ orderedItems, section }) => (
            <SummarySection key={section.uri} section={section}>
              {renderOrderedItems({
                orderedItems,
                responses,
                renderGroup: (props) => <SummaryGroup {...props} />,
                renderField: (props) => <SummaryField {...props} />,
                renderGroupFieldSet: (props) => (
                  <SummaryGroupFieldSet {...props} />
                ),
              })}
            </SummarySection>
          ))}
        </div>
      )}
    </div>
  </div>
);
